import React from 'react';
import { Helmet } from 'react-helmet-async';

// Define company and app details for reuse
const APP_NAME = 'Coooly';
const APP_DESCRIPTION = 'Invoice management software for dental hygienists and therapists working across multiple practices.';
const COMPANY_NAME = 'Coooly Ltd';
const BASE_URL = 'https://coooly.co.uk'; // Update with your actual domain

const LandingSEO = () => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{APP_NAME} - Dental Invoice Management Software</title>
      <meta name="description" content={APP_DESCRIPTION} />
      <meta name="keywords" content="dental invoice software, hygienist invoice app, dental therapist invoicing, multiple practice management" />
      
      {/* OpenGraph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={BASE_URL} />
      <meta property="og:title" content={`${APP_NAME} - Dental Invoice Management Software`} />
      <meta property="og:description" content={APP_DESCRIPTION} />
      <meta property="og:image" content={`${BASE_URL}/og-image.png`} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={BASE_URL} />
      <meta property="twitter:title" content={`${APP_NAME} - Dental Invoice Management Software`} />
      <meta property="twitter:description" content={APP_DESCRIPTION} />
      <meta property="twitter:image" content={`${BASE_URL}/twitter-image.png`} />
      
      {/* Additional SEO tags */}
      <meta name="application-name" content={APP_NAME} />
      <meta name="apple-mobile-web-app-title" content={APP_NAME} />
      <link rel="canonical" href={BASE_URL} />
      
      {/* Additional Schema.org markup can be included here if needed */}
    </Helmet>
  );
};

export default LandingSEO;
